export default function Hero() {
  const stats = [
    { value: "1400+", label: "持续追踪议题" },
    { value: "2.1w+", label: "整理网友热评" },
    { value: "31 省", label: "读者分布区域" },
  ];

  return (
    <section id="top" className="relative overflow-hidden">
      {/* background image + overlay */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=wide%20editorial%20abstract%20banner%20in%20warm%20terracotta%20clay%2C%20burnt%20orange%20and%20cream%20cream%20tones%2C%20soft%20morphing%20geometric%20shapes%20with%20speech%20bubbles%20and%20discussion%20lines%2C%20modern%20minimalist%20art%20direction%2C%20high%20detail%20textured%20layers%20no%20people&width=1800&height=900&seq=hero-main-1&orientation=landscape"
          alt="九一吃瓜 暖调编辑部风格背景"
          className="absolute inset-0 h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-background-950/80"></div>
      </div>

      <div className="relative mx-auto max-w-6xl px-4 md:px-6 pt-32 md:pt-40 pb-16 md:pb-20 w-full">
        <div className="flex flex-col items-start max-w-3xl">
          <p className="inline-flex items-center gap-2 rounded-full border border-white/30 bg-white/10 px-3 py-1 text-xs md:text-sm text-white backdrop-blur">
            <i className="ri-radio-2-line text-base text-secondary-300" aria-hidden="true"></i>
            每周更新评论区风向 · 第 36 期
          </p>

          <h1 className="mt-5 font-heading text-3xl md:text-5xl lg:text-6xl font-black leading-tight text-white">
            把评论区
            <span className="text-secondary-300">，</span>
            <br className="hidden md:block" />
            讲给你听
          </h1>

          <p className="mt-5 max-w-2xl text-sm md:text-lg leading-relaxed text-white/85">
            <strong className="font-semibold text-white">九一吃瓜</strong>
            是一个关注“大家怎么看”的评论区风向标。我们不制造话题，只帮你还原网友热评、观点与争论焦点，
            快速掌握一件事的舆论脉络，告别被带节奏。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <a
              href="#hot"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-fire-line text-lg" aria-hidden="true"></i>
              看看今日热榜
            </a>
            <a
              href="#debate"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-white/50 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-white/15"
            >
              <i className="ri-discuss-line text-lg" aria-hidden="true"></i>
              围观争论焦点
            </a>
          </div>

          {/* stats */}
          <dl className="mt-10 grid w-full max-w-lg grid-cols-3 divide-x divide-white/20 border-t border-white/20 pt-6">
            {stats.map((s, i) => (
              <div key={s.label} className={`flex flex-col px-3 ${i === 1 ? "border-x" : ""}`}>
                <dd className={`font-heading text-xl md:text-3xl font-black ${i === 1 ? "text-secondary-300" : "text-white"}`}>
                  {s.value}
                </dd>
                <dt className="mt-1 text-xs md:text-sm text-white/70">{s.label}</dt>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}